import React, { FormEvent, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import Textfield from '@atlaskit/textfield';
import Tooltip from '@atlaskit/tooltip';

import { InputSearchIcon } from '@qality/common-components/src/atoms/InputSearchIcon';
import { DEBOUNCE_DELAY_MS } from '@qality/common-config';

type Props = {
  value: string;
  onChange: (searchValue: string) => void;
  isDisabled?: boolean;
  tooltipContent?: string;
  width?: number;
  placeholder?: string;
};

export default function TextSearch({
  value,
  onChange,
  isDisabled = false,
  tooltipContent,
  width,
  placeholder = 'Contains text',
}: Props): JSX.Element {
  const [currentValue, setCurrentValue] = useState(value);

  const onChangeDebounced = React.useCallback(
    debounce(onChange, DEBOUNCE_DELAY_MS),
    []
  );

  const handleInputChange = (e: FormEvent<HTMLInputElement>) => {
    setCurrentValue(e.currentTarget.value);
    onChangeDebounced(e.currentTarget.value);
  };

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <Tooltip
      content={isDisabled && tooltipContent}
      testId='disabled-search-tooltip'
    >
      <Textfield
        value={currentValue}
        isDisabled={isDisabled}
        placeholder={placeholder}
        testId='search-text-field'
        onChange={handleInputChange}
        width={width}
        elemBeforeInput={<InputSearchIcon />}
      />
    </Tooltip>
  );
}
